App.SmOrderAddressMapComponent = Em.Component.extend
  classNames: ['order-address-map']
  session: Em.inject.service()

  fullScreen: false
  
  registerMap:(->
    return unless @$()?.get(0)
    unless window.mapgl
      setTimeout =>
        @registerMap()
      , 1000
      return

    order = @get('order')
    lat = order.get('latitude') or order.get('restaurant.latitude')
    lon = order.get('longitude') or order.get('restaurant.longitude')
    coordinates = [lon, lat]
    mapOptions =
      zoom: 17
      center: coordinates
      disableDefaultUI: true
      zoomControl: false
      key: @get('session.twoGis_token')
      style: 'c080bb6a-8134-4993-93a1-5b4d8c36a59b'
    
    map = new mapgl.Map @$().get(0), mapOptions
    map.on 'click', (eventData) =>
      @coordinatesChange(eventData.lngLat)
    control = new mapgl.Control map, "<button class='sm-button small gray'><img src='#{@get('controlImage')}'/></button>", {
      position: 'topLeft',
    }
    $(control.getContainer()).find('button').on 'click', (ev) =>
      @set('fullScreen', not @get('fullScreen'))
      $('.order-address-map').toggleClass('extended')
      map.destroy()
      @registerMap()

    @set('orderMarker', Ember.Object.create())
    @set('map', map)
    @get('obtainDefers').forEach (defer) =>
      defer.resolve(map)
    @set 'animateNewMarkers', true
    @initMarkers(coordinates)
    @setCenter(coordinates)
  ).on('didInsertElement')

  initializeProps:( ->
    @set 'obtainDefers', Em.A([])
  ).on('init')

  coordinatesObserver: (->
    order = @get('order')
    lat = order.get('latitude')
    lon = order.get('longitude')
    coordinates = [lon, lat]
    @coordinatesChange(coordinates)
    @setCenter(coordinates)
  ).observes('order.latitude', 'order.longitude')

  controlImage: (->
    unless @get('fullScreen') then "images/full-screen.svg" else "images/close.svg"
  ).property('fullScreen')

  obtainMap: ->
    defer = Em.RSVP.defer()

    if @get 'initialized'
      defer.resolve @get('map')
    else
      @get('obtainDefers').pushObject defer
    defer.promise
  
  initMarkers: (coordinates)->
    order = @get('order')
    map = @get('map')
    icon = "images/marker-destination@2x.png"
    marker = new mapgl.Marker map,
      coordinates:  coordinates
      icon:         icon,
      size:         [20,28]
    @get('orderMarker').set(order.get('id'), marker)
    

  setCenter: (coordinates) ->
    map = @get('map')
    map.setCenter(coordinates)
  
  
  coordinatesChange: (coordinates) ->
    order = @get('order')
    marker = @get('orderMarker').get(order.get('id'))
    marker.setCoordinates(coordinates)

    [longitude, latitude] = coordinates

    order.setProperties
      coordinates: "POINT (#{longitude} #{latitude})"
      longitude
      latitude

    order.save().then (data) =>
      order.reverseGeocode().then (data) =>
        order.setProperties
          address: data.order.address
          address_string: data.order.address_string
          address_text: data.order.address_text